import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import moCompanyDistribution, { changeActiveType } from './store';
import Empty from '@comp/empty/index';
import CityMap from './company-chart'
import CommonTab from '../../component/common-Tab';
import MapTopRanking from './map-top-ranking';

interface IProps { }
interface IState { }

const CompanyDistribution = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { distributList, type } = moCompanyDistribution;

  const tabList = [
    { code: 'city', value: '城市' },
    { code: 'city_grade', value: '类型' },
    { code: 'city_region', value: '区域' },
  ];

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="company-distribution_10">
      <strong className="sub-11">公司总部分布</strong>
      {!isEmpty(distributList) ? (
        <section>
          <section className='mobility-tab'>
            <CommonTab list={tabList} active={type} onChange={(val: string) => { changeActiveType(val) }} />
          </section>
          <section className="section-166">
            <CityMap />
            <MapTopRanking />
          </section>
        </section>
      ) : <Empty padding="50px 0" />}
    </section>
  );
};

export default observer(CompanyDistribution);
